import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { IDI_INSPECTION_SEARCH_START_LOADING, IDI_INSPECTION_SEARCH_END_LOADING, IDI_INSPECTION_SEARCH_LOADED, SET_IDI_INSPECTION_FILTER } from "../constants/IdiInspectionConstants";
import { IDI_INSPECTION_START_LOADING, IDI_INSPECTION_END_LOADING, IDI_INSPECTION_LOADED } from "../constants/IdiInspectionConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
    },
    loadingFBO: false,
    fbo: null
};

const IdiInspectionReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_INSPECTION_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_INSPECTION_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_INSPECTION_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_IDI_INSPECTION_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case IDI_INSPECTION_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case IDI_INSPECTION_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case IDI_INSPECTION_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IdiInspectionReducer;